var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import { User } from '@/models/User';
// import { Dialog } from '@/dialog';
// import { RouteNameEnum } from '@/router/RouteNameEnum';
// import { rpcClient } from '@/http';
import MfaOutput from '@/components/MfaOutput/MfaOutput';
import MfaInput from '@/components/MfaInput/MfaInput';
import { Mfa } from '@/models/Mfa';
import { RouteNameEnum } from '@/router/RouteName';
import { logGuard } from '@/router/helpers';
let AuthSetMfa = class AuthSetMfa extends Vue {
    constructor() {
        // #region @Props
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.currentStep = 1;
        this.isLoading = false;
        this.mfaOutput = null;
        this.mfaToken1 = '';
        this.mfaToken2 = '';
        this.isLoadingMfaToken = false;
        this.errorMessage = '';
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    mounted() {
        this.initialize();
    }
    initialize() {
        this.generateNewMfaToken();
    }
    // #endregion
    // #region Class methods
    getUpdateMfaPayload() {
        return {
            secret: this.mfaOutput && this.mfaOutput.secret || '',
            token: this.mfaToken1,
            token_verify: this.mfaToken2,
        };
    }
    setMfaBooleanToTrueOnStoredUser() {
        const user = this.$store.getters.user;
        if (user) {
            user.has_mfa_token = true;
            this.$store.dispatch('userAuthenticated', user);
        }
    }
    async onRequestToGenerateNewMfaToken() {
        await this.generateNewMfaToken();
    }
    async onUpdateMfaButtonClick() {
        await this.updateMfa();
    }
    // #endregion
    // #region Async methods
    // FIXME
    async generateNewMfaToken() {
        this.isLoadingMfaToken = true;
        try {
            this.mfaOutput = await new Mfa().all();
        }
        catch (error) {
            // do nothing
        }
        this.isLoadingMfaToken = false;
    }
    // FIXME
    async updateMfa() {
        if (!this.canUpdateMfaToken) {
            return;
        }
        this.isLoading = true;
        try {
            this.mfaOutput = await new Mfa()
                .create(this.getUpdateMfaPayload());
            if (this.user) {
                this.setMfaBooleanToTrueOnStoredUser();
            }
            else {
                this.$router.push({ name: RouteNameEnum.HOME }).catch(() => {
                    // in case an Guard blocks and reroutes you as well we prevent it from throwing nasty error
                    // @see https://stackoverflow.com/questions/62223195/vue-router-uncaught-in-promise-error-redirected-from-login-to-via-a
                });
            }
            // Dialog.successClose({
            //   title: this.$tc('dialog_success_set_mfa_title'),
            //   text: this.$tc('dialog_success_set_mfa_text'),
            //   buttons: {
            //     confirm: {
            //       action: () => {
            //         if (this.user) {
            //           this.$set(this.user, 'has_mfa_token', true);
            //         } else {
            //           this.$router.push({ name: RouteNameEnum.LOGIN });
            //         }
            //       },
            //     },
            //   },
            // });
        }
        catch (unknownError) {
            const error = unknownError;
            const errorStatus = error
                && error.response
                && error.response.status
                ? error.response.status
                : undefined;
            const errorMessage = error
                && error.response
                && error.response.data
                && error.response.data.message
                ? error.response.data.message
                : undefined;
            if (errorStatus === 422 && errorMessage === 'The given data was invalid.') {
                this.errorMessage = 'Onjuiste invoer, probeer het opnieuw.';
            }
            logGuard('[AUTH_SET_MFA] errorStatus', errorStatus, 'errorMessage', errorMessage);
        }
        this.isLoading = false;
    }
    // #endregion
    // #region Getters & Setters
    get canUpdateMfaToken() {
        return !!(this.mfaOutput && !this.isLoading && this.mfaTokensValid);
    }
    get mfaTokensValid() {
        return this.mfaToken1.length === 6 && this.mfaToken2.length === 6;
    }
};
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], AuthSetMfa.prototype, "isDialog", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], AuthSetMfa.prototype, "userId", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof User !== "undefined" && User) === "function" ? _a : Object)
], AuthSetMfa.prototype, "user", void 0);
AuthSetMfa = __decorate([
    Component({
        components: {
            MfaOutput,
            MfaInput,
        },
    })
], AuthSetMfa);
export default AuthSetMfa;
